import { useEffect, useState } from 'react'
import Notification from './notification'
import notificationsEventBus from './notifications-event-bus'

export default function useNotifications(maxNotificationCount = 3) {
  const [notifications, setNotifications] = useState<Notification[]>([])

  useEffect(() => {
    const onNotificationShow = (notification: Notification) => {
      setNotifications(prevNotifications => {
        if (prevNotifications.includes(notification)) return prevNotifications

        const newNotifications = [...prevNotifications, notification]
        while (newNotifications.length > maxNotificationCount) {
          newNotifications.shift()
        }
        return newNotifications
      })

      if (notification.durationMs < 2 ** 31 - 1)
        setTimeout(() => closeNotification(notification.id), notification.durationMs)
    }

    notificationsEventBus.on('show', onNotificationShow)

    return () => notificationsEventBus.off('show', onNotificationShow)
  }, [maxNotificationCount])

  const closeNotification = (idOrNotification: string | Notification) => {
    if (typeof idOrNotification === 'string') {
      return setNotifications(prevNotifications =>
        prevNotifications.filter(notification => notification.id !== idOrNotification)
      )
    }

    return setNotifications(prevNotifications =>
      prevNotifications.filter(notification => notification.id !== idOrNotification.id)
    )
  }

  return { notifications, closeNotification }
}
